import React, { useState, useRef, useEffect } from "react"
import { Tooltip, Box } from "@kohler-dsm-library/kohler-core"
import { useTranslation } from "next-i18next"
import { sanitizeAndDecodeHtml } from "@/utils/helper"
import { LIST_PRICE } from "@/components/ShopTheRoomDetails/Analytics/constant"

const RoomListPriceTooltip = () => {
  const [open, setOpen] = useState(false)
  const [openedByClick, setOpenedByClick] = useState(false)
  const buttonRef = useRef(null)

  useEffect(() => {
    if (!open || !openedByClick) return
    /**
     * Handles click events outside the button to close the tooltip.
     *
     * @param {MouseEvent} event - The mouse event triggered by clicking anywhere in the document.
     */
    function handleClickOutside(event) {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setOpen(false)
        setOpenedByClick(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [open, openedByClick])

  const { t } = useTranslation()
  const listPricetooltip = t("kf.pdp.label.listPriceInfo")
  return (
    <Box mod="white" style={{ maxWidth: "200px" }}>
      <Tooltip
        label={sanitizeAndDecodeHtml(listPricetooltip)}
        position="bottom"
        multiline={true}
        open={open}
        opacity={open ? 1 : 0}
        maxWidth="300px"
      >
        <button
          ref={buttonRef}
          style={{ textDecoration: "underline" }}
          type="button"
          onClick={() => {
            if (!open) {
              setOpen(true)
              setOpenedByClick(true)
            } else {
              setOpen(false)
              setOpenedByClick(false)
            }
          }}
          onMouseEnter={() => {
            setOpen(true)
            setOpenedByClick(false)
          }}
          onMouseLeave={() => {
            setOpen(false)
            setOpenedByClick(false)
          }}
        >
          {LIST_PRICE}
        </button>
      </Tooltip>
    </Box>
  )
}
export default RoomListPriceTooltip
